import {gsap} from 'gsap';
import {PunkRocker} from '../../../PunkRocker';
import {GameData} from "../../../server/data/GameData";
import {PRGameMode} from "../../../server/PRGameMode";
import {SoundManager} from "../../../sound/SoundManager";

export class SplashViewFreeSpins extends PIXI.Container {
    private _spineContainer: PIXI.Sprite;
    private _spine: PIXI.spine.Spine | null;
    private _bonusType: number;
    private ANIMATION_NAMES: string[] = ["Poster_Disobey", "Poster_Chaos", "Poster_MassTransitBBQS"];
    private _gameData: GameData;

    constructor() {
        super();
        this.initAnimations();
    }

    public setData(data: GameData): void {
        this._gameData = data;
        const mode: string = data.nextMode;
        this._bonusType = (mode === PRGameMode.FREESPIN_LEVEL_ONE ? 1 : (mode === PRGameMode.FREESPIN_LEVEL_TWO ? 2 : 3));
    }

    public play(): gsap.core.Timeline {
        PunkRocker.screenDimmer.show();
        if (this._spine) {
            this._spine.destroy();
            this._spine = null;
        }

        this._spine = new PIXI.spine.Spine(PunkRocker.assetLoader.getSpineAsset(this.ANIMATION_NAMES[this._bonusType - 1]));
        this.visible = true;

        let isUpgrade: boolean = false;

        if (this._gameData.isFreeSpin) {
            const currMode: PRGameMode = this._gameData.mode,
                nextMode: PRGameMode = this._gameData.nextMode;

            isUpgrade = ((currMode === PRGameMode.FREESPIN_LEVEL_ONE
                    && (nextMode === PRGameMode.FREESPIN_LEVEL_TWO || nextMode === PRGameMode.FREESPIN_LEVEL_THREE))
                || (currMode === PRGameMode.FREESPIN_LEVEL_TWO && nextMode === PRGameMode.FREESPIN_LEVEL_THREE));

        }

        const tl: gsap.core.Timeline = new gsap.core.Timeline();

        tl.add([
            () => {
                const introAnimName: string = isUpgrade ? "upgrade" : "intro";

                this._spineContainer.addChild(this._spine!);
                this._spine!.state.setAnimation(0, introAnimName, false);
            },
            gsap.to(this._spine, {alpha: 1, duration: 0.2})
        ]);

        tl.add(() => {
            const loopAnimName: string = isUpgrade ? "upgradeLoop" : "loop";

            this._spine!.state.setAnimation(0, loopAnimName, true);
        });

        return tl;
    }

    public stop(): gsap.core.Timeline {
        SoundManager.stopBonusTypeAmbiance(); // #244
        SoundManager.playAmbientLoop(this._gameData.nextMode);
        return gsap.timeline().add([
            //PunkRocker.screenDimmer.fadeOut(),
            gsap.to(this._spine, 0.2, {alpha: 0})
        ]).add(() => {
            PunkRocker.keypadPlugin.show();
            PunkRocker.screenDimmer.hide();
            this.visible = false;
        });
    }

    private initAnimations(): void {
        this._spineContainer = new PIXI.Sprite();
        this.addChild(this._spineContainer);
        this._spineContainer.position.set(360, 340);
        this.visible = false;
    }
}
